import Image from '@/components/common/Image'
import classNames from 'classnames/bind'
import { HTMLAttributes } from 'react'
import styles from './style.module.scss'

const cx = classNames.bind(styles)

const AboutPageLayout = ({ children, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cx('about-page-layout')} {...props}>
      <div className={cx('about-page-layout__logo')}>
        <Image src={`/images/svg/logo_live_mall_club.svg`} alt={'LiveMallClub'} width={190} height={60} />
      </div>
      {children}
    </div>
  )
}

const SectionTitle = ({ children, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h1 className={cx('page-title')} {...props}>
      <span className={cx('page-title__text')}>{children}</span>
    </h1>
  )
}

AboutPageLayout.SectionTitle = SectionTitle
export default AboutPageLayout
